// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import App from './App';
import store from './store';
import VueResource from 'vue-resource';
import VueRouter from 'vue-router';

export const messagebus = new Vue();

Vue.use(VueResource);
Vue.use(VueRouter);
Vue.config.productionTip = false;

/* eslint-disable no-new */
new Vue({
    store,
    // components: { App },
    router: (new VueRouter({
        mode: 'hash',
        base: '',
        routes: [
            { path: '', component: App, props: (route) => ({ product: route.query.product, billFreq: route.query.billFreq }) }
        ]
    }))
}).$mount('#baser');



// WEBPACK FOOTER //
// ./src/main.js